import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Button from './Button';

function Cta() {
    const data = useStaticQuery(graphql`
        query {
            bgImage: file(relativePath: { eq: "holobrn-saudi-feature.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
        }
    `);

    const imageData = getImage(data.bgImage);

    return (
        <div className="grid grid-cols-12 w-full h-full relative m-0 p-0">
            <GatsbyImage
                className="absolute w-full h-full"
                style={{ position: "absolute", zIndex: -1 }}
                image={imageData}
                alt="Background Image"
            />
            <div className="absolute inset-0 bg-black opacity-40"></div>
            <div className="col-span-12 md:col-start-2 md:col-span-10 pt-24 pb-36 px-8 md:px-0 relative z-10">
                <h2 className="text-4xl md:text-6xl text-white mb-8 font-semibold">Ready to chat with<br /> a specialist?</h2>
                <Button color="holborn-greenWhite" href="/enquiry-form/">
                    Get started
                </Button>
            </div>
        </div>
    )
}

export default Cta;